import { Payload, Types } from 'states/dux/user/types'
import { Action } from 'states/types'

const set = (payload: Payload): Action<Payload> => {
  return {
    type: Types.SET,
    payload
  }
}

const update = (payload: Partial<Payload>): Action<Partial<Payload>> => {
  return {
    type: Types.UPDATE,
    payload
  }
}

export { set, update }
